import packageJson from '../../package.json';

const getURL = () => {
  let url = "";
      switch(packageJson.buildType){
          case "DEV":
          default:
              url = process.env.REACT_APP_PRODUCTDATA_URL_DEV;
              break;
          case "QA":
          case "PROD":
              url = process.env.REACT_APP_PRODUCTDATA_URL_PROD;
              break;
      }
      return url;
}

const getFuncKey = () => {
  let url = "";
      switch(packageJson.buildType){
          case "DEV":
          default:
              url = process.env.REACT_APP_PRODUCTDATA_FUNCTIONKEY_DEV;
              break;
          case "QA":
          case "PROD":
              url = process.env.REACT_APP_PRODUCTDATA_FUNCTIONKEY_PROD;
              break;
      }
      return url;
}

const fetchData = async ( url, params = {}) => {
  try {
    const baseUrl = getURL();
    // Construct the full URL using the URL constructor
    const fullUrl = new URL(url, baseUrl);
    
    // Append query parameters from the params object
    Object.keys(params).forEach(key => {
      fullUrl.searchParams.append(key, params[key]);
    });
    
    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'x-functions-key': getFuncKey(),
        'Cache-Control': 'max-age=14400', // Cache for 4 hours
      },
      cache: 'default', // The cache option is supported by fetch
    });
    
    if (!response.ok) {
      if (response.status === 500) {
        console.error('A server error occurred (500). Please try again later.');
        return null;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Fetch error:', err);
    throw err;
  }
};

export const getCategories = async () => await fetchData('/api/categories');

export const getFamilies = async () => await fetchData('/api/families');

export const getFamiliesByCategoryId = async (categoryId) => await fetchData('/api/familiesByCategoryId', { categoryId });

export const getFamilyFromFamilyId = async (familyId) => await fetchData('/api/familyByFamilyId', { familyId });

export const getSalesOrgs = async () => await fetchData('/api/salesorgs');

export const getProducts = async (familyId) => await fetchData('/api/products', { familyId });

export const getLofts = async (familyId) => await fetchData('/api/lofts', { familyId });

export const getShaftsByFamily = async (familyId) => await fetchData('/api/shaftsByFamily', { familyId });

export const getProductCategories = async () => await fetchData('/api/productCategories');